import { httpUrl } from './httpUrl'
import axios from './axios'
import Vue from 'vue'
// import store from '../../store/index'
// import router from '../../router/index'
import { filterEmptyData } from '../../utils/js/mixin'
import * as msgUtils from 'utils/js/msgUtils.js';//工具类
import storageUtils from 'utils/js/storageUtils.js'
const qs = require('qs')

/**
 * 连接错误
 * @param {*} error
 * @param {*} reject
 * @param {是否提示} isMsg
 */
function connectError(error,reject,isMsg) {//服务器连接错误
    reject(error);
    if(isMsg){
        msgUtils.messageError(`服务器连接失败，请联系管理员。错误:${error}`);
    }
}

/**
 * 访问成功
 * @param {*} res
 * @param {*} resolve
 * @param {*} reject
 * @param {是否提示} isMsg
 */
function success(res,resolve,reject,isMsg){
    if(res&&res.data){
        if(res.data.success){
            resolve(res.data)
        }else{
            failCode(res.data,reject,isMsg);
            // reject(res.data);
        }
    }else{
        reject();
        if(isMsg){
            msgUtils.messageError("返回数据结构错误");
        }
    }
}


/**
 * 错误代码
 * @param {*} data
 * @param {是否提示} isMsg
 */
function failCode(data,reject,isMsg){//返回编码错误，如：非法的token;其他客户端登录了;Token 过期了等
    if(data.code=='498'){//带有敏感词汇
        msgUtils.alertConfirm("操作失败！<br/>您编辑的文字内容涉及敏感词汇，请文明用语","告警",{dangerouslyUseHTMLString: true});
        reject(data);
    }else{
        if(isMsg){
            msgUtils.messageError(data.message);
        }
        // if(data.code=='401'||data.code=='402'){//401token过期或无效，需要重新登录.  402	需要重新登录
        if(data.code=='402'){//402 token失效，需要重新登录
            if(!isMsg){
                msgUtils.messageError(data.message);
            }
            storageUtils.clear();
            window.location.href=httpUrl["clooudLogin"];
            // router.push({path:'/login'});
        }else{
            reject(data);
        }
    }
}

/**
 * post
 * @param {接口名字} apiName
 * @param {参数} data
 * @param {是否提示} isMsg
 * @param {是否关闭加载框} isCloseProgress
 */
export function post(apiName, data = {},isMsg=true,isCloseProgress=true) {
    axios.defaults.headers['Content-Type']='application/x-www-form-urlencoded; charset=UTF-8';

    //msgUtils.progressLoad(true)//加载进度框
    let url = ''
    if ((apiName !== 'clooudLogin' || apiName !== 'getTokenUser')&&storageUtils.getUserInfo()) {
        // data.Authorization = storageUtils.getUserInfo().token;
        axios.defaults.headers['Authorization'] = storageUtils.getUserInfo().token;
    }
    url = httpUrl[apiName];
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(filterEmptyData(data)))
        // axios.post(url, data)
        .then(res => {
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            success(res,resolve,reject,isMsg);
        })
        .catch(error => {
            console.log(error);
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            connectError(error,reject,isMsg);
        })
    })
}
/**
 * post
 * @param {接口名字} apiName
 * @param {参数} data
 * @param {是否提示} isMsg
 * @param {是否关闭加载框} isCloseProgress
 */
export function post2(apiName, data = {},isMsg=true,isCloseProgress=true) {
    axios.defaults.headers['Content-Type']='application/x-www-form-urlencoded; charset=UTF-8';

    //msgUtils.progressLoad(true)//加载进度框
    let url = ''
    if ((apiName !== 'clooudLogin' || apiName !== 'getTokenUser')&&storageUtils.getUserInfo()) {
        // data.Authorization = storageUtils.getUserInfo().token;
        axios.defaults.headers['Authorization'] = storageUtils.getUserInfo().token;
    }
    url = httpUrl[apiName];
    return new Promise((resolve, reject) => {
        axios.post(url, filterEmptyData(data))
        // axios.post(url, data)
        .then(res => {
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            success(res,resolve,reject,isMsg);
        })
        .catch(error => {
            console.log(error);
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            connectError(error,reject,isMsg);
        })
    })
}

/**
 * post
 * @param {接口名字} apiName
 * @param {参数} data
 * @param {是否提示} isMsg
 * @param {是否关闭加载框} isCloseProgress
 */
export function postJson(apiName, data = {},isMsg=true,isCloseProgress=true) {
    axios.defaults.headers['Content-Type']='application/json;charset=utf-8';

    //msgUtils.progressLoad(true)//加载进度框
    let url = ''
    if ((apiName !== 'clooudLogin' || apiName !== 'getTokenUser')&&storageUtils.getUserInfo()) {
        // data.Authorization = storageUtils.getUserInfo().token;
        axios.defaults.headers['Authorization'] = storageUtils.getUserInfo().token;
    }
    url = httpUrl[apiName];
    return new Promise((resolve, reject) => {
        axios.post(url,filterEmptyData(data))
        // axios.post(url, data)
        .then(res => {
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            success(res,resolve,reject,isMsg);
        })
        .catch(error => {
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            connectError(error,reject,isMsg);
        })
    })
}


/**
 * get
 * @param {接口名字} apiName
 * @param {参数} data
 * @param {是否提示} isMsg
 * @param {是否关闭加载框} isCloseProgress
 */
export function get(apiName, data = {},isMsg=false,isCloseProgress=true) {
    axios.defaults.headers['Content-Type']='application/x-www-form-urlencoded; charset=UTF-8';
    //msgUtils.progressLoad(true)

    if ((apiName !== 'clooudLogin' || apiName !== 'getTokenUser')&&storageUtils.getUserInfo()) {
        // data.Authorization = storageUtils.getUserInfo().token;
        axios.defaults.headers['Authorization'] = storageUtils.getUserInfo().token;
    }
    return new Promise((resolve, reject) => {
        axios.get(httpUrl[apiName], { params: filterEmptyData(data)})
        // axios.get(qiuqiuAdminUrl + apiList[apiName], { params: data})
        .then(res => {
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            success(res,resolve,reject,isMsg)
        })
        .catch(error => {
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            connectError(error,reject,isMsg)
        })
    })
}

/**
 * get
 * @param {接口名字} apiName
 * @param {参数} data
 * @param {是否提示} isMsg
 * @param {是否关闭加载框} isCloseProgress
 */
 export function getNewDetail(apiName, data = {},isMsg=false,isCloseProgress=true) {
    axios.defaults.headers['Content-Type']='application/x-www-form-urlencoded; charset=UTF-8';
    //msgUtils.progressLoad(true)

    // if ((apiName !== 'clooudLogin' || apiName !== 'getTokenUser')&&storageUtils.getUserInfo()) {
    //     // data.Authorization = storageUtils.getUserInfo().token;
    //     axios.defaults.headers['Authorization'] = storageUtils.getUserInfo().token;
    // }
    return new Promise((resolve, reject) => {
        axios.get(httpUrl[apiName], { params: filterEmptyData(data)})
        // axios.get(qiuqiuAdminUrl + apiList[apiName], { params: data})
        .then(res => {
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            success(res,resolve,reject,isMsg)
        })
        .catch(error => {
            if(isCloseProgress){
                msgUtils.progressLoad("",false)
            }
            connectError(error,reject,isMsg)
        })
    })
}
